module.exports = __webpack_public_path__ + "html/about_26f8971afef136c12544a4183ca98996.html";


//////////////////
// WEBPACK FOOTER
// ./app/assets/html/about.html
// module id = KkOC
// module chunks = 118